import { DataStore } from "./data.store"
import MockAdapter from "axios-mock-adapter"
import axios from "axios"

export class Backend {
    private datastore: DataStore
    private mockAdapter: MockAdapter

    public constructor() {
        this.mockAdapter = new MockAdapter(axios)
        this.datastore = new DataStore()
    }

    public start(): void {
        this.initialize()
    }

    private initialize(): void {
        this.mockAdapter.onPost("/login").reply(200, this.datastore.authTokens)
        this.mockAdapter.onPost(/\/forgot-password/).reply(201, undefined)
        this.mockAdapter.onPost(/\/logout/).reply(200, undefined)
        this.mockAdapter.onPost(/\/bug-report/).reply(200, undefined)
        this.mockAdapter.onPost(/analytics\/overview/).reply(200, this.datastore.analyticsOverview)
        this.mockAdapter.onPost(/analytics\/expenses\/grouped/).reply(function (config) {
            const datastore: DataStore = new DataStore()
            const data: any = JSON.parse(config.data || {})
            if (data["groupingField"] === "costCenter") {
                return [200, datastore.groupedExpensesPerCostCenter]
            }

            return [200, datastore.groupedExpensesPerUser]
        })
        this.mockAdapter.onPost(/analytics\/expenses\/costcenter\/overtime/).reply(200, this.datastore.costCentersOvertime)
        this.mockAdapter.onPost(/analytics\/costcenters\/budget/).reply(200, this.datastore.costCenterBudgets)
        this.mockAdapter.onPost(/analytics\/costcenters\/overtime\/[a-zA-Z0-9&=]*/).reply(200, this.datastore.costCentersOvertime)
        this.mockAdapter.onPost(/analytics\/costcenters\/employee\/[a-zA-Z0-9&=]*/).reply(200, this.datastore.costCentersEmployee)
        this.mockAdapter.onGet(/\/expenses\/\?page=[a-zA-Z0-9&=\[\],]+/).reply(200, this.datastore.paginatedExpenses)
        this.mockAdapter.onGet(/expenses\/analytics\/counts\?[a-zA-Z0-9&=]*/).reply(200, this.datastore.expenseCountsAnalytics)
        this.mockAdapter.onGet(/vendors\?limit=[a-zA-Z0-9&=]+/).reply(200, this.paginate(this.datastore.vendors))
        this.mockAdapter.onGet(/\/users\?limit=[a-zA-Z0-9&=]+/).reply(200, this.paginate(this.datastore.users))
        this.mockAdapter.onDelete(/\/users/).reply(200, undefined)
        this.mockAdapter.onGet(/\/costcenters\?limit=[a-zA-Z0-9&=]+/).reply(200, this.paginate(this.datastore.costCenters))
        this.mockAdapter.onGet(/\/banking/).reply(200, [this.datastore.bankConnection])
        this.mockAdapter.onGet(/\/expenseaccounts/).reply(200, this.datastore.expenseAccounts)
        this.mockAdapter.onGet("http://localhost:8888/api/payment/plans").reply(200, this.datastore.paymentPlan)
        this.mockAdapter.onGet("/payment").reply(200, this.datastore.payment)
        this.mockAdapter.onGet(/\/activity\/\?limit=[a-zA-Z0-9&=]+/).reply(200, this.paginate(this.datastore.activities))
        this.mockAdapter.onGet(/\/expenses\/analytics\/counts\?[a-zA-Z0-9&=]*/).reply(200, 1)
        this.mockAdapter.onGet("http://localhost:8888/api/version").reply(200, this.version)
        this.mockAdapter.onGet("http://localhost:8888/api/company").reply(200, this.datastore.company)
        this.mockAdapter.onGet("/currency/exchange").reply(200, this.datastore.currencyExchange)
        this.mockAdapter.onGet(/\/users\/[A-Za-z0-9]{24}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.users, id)
            return [200, data]
        })
        this.mockAdapter.onGet(/\/vendors\/[A-Za-z0-9]{24}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.vendors, id)
            return [200, data]
        })
        this.mockAdapter.onGet(/\/expenses\/[A-Za-z0-9]{24}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.expenses, id)
            return [200, data]
        })
        this.mockAdapter.onPut(/\/expenses\/[A-Za-z0-9]{24}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.expenses, id)
            return [200, data]
        })
        this.mockAdapter.onGet(/\/costcenters\/[0-9]{2}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{2}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.costCenters, id)
            return [200, data]
        })
        this.mockAdapter.onPut(/\/users\/[A-Za-z0-9]{24}\/settings/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.users, id)
            return [200, data]
        })
        this.mockAdapter.onPut(/\/users\/[A-Za-z0-9]{24}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.users, id)
            return [200, data]
        })
        this.mockAdapter.onPut(/\/vendors\/[A-Za-z0-9]{24}/).reply(function (config) {
            const datastore = new DataStore()
            const url = config.url || ""
            const matches = url.match(/[A-Za-z0-9]{24}/) || [""]
            const id = matches[0]
            const data = datastore.findById(datastore.users, id)
            return [200, data]
        })
        this.mockAdapter.onPut("/company").reply(200, this.datastore.company)
        this.mockAdapter.onPut("expenseaccounts").reply(200, this.datastore.expenseAccounts)
        this.mockAdapter.onDelete(/\/costcenters/).reply(200, undefined)
        this.mockAdapter.onDelete(/\/vendors/).reply(200, undefined)
        this.mockAdapter.onDelete(/\/expenses/).reply(200, undefined)
    }

    private get version(): any {
        return {
            apiVersion: 1,
        }
    }

    private paginate(docs: any[]): any {
        return {
            docs: docs,
        }
    }
}
